import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LooksTwoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"looks_two"}/>
}
